import { api } from '@/lib/api'
import type { OrderTicket, OrderTicketRequest } from '@/types/orderTicket'

export async function createOrderTicket(
  positionId: number,
  body: OrderTicketRequest,
): Promise<OrderTicket> {
  const { data } = await api.post<OrderTicket>(`/positions/${positionId}/order-tickets`, body)
  return data
}

export async function markTicketCopied(ticketId: number): Promise<OrderTicket> {
  const { data } = await api.patch<OrderTicket>(`/order-tickets/${ticketId}/copied`)
  return data
}
